/**
 * Constants
 */
export const SET_SIZE = 'layout@SET_SIZE';

/**
 * Actions creator
 */
export const setSize = payload => ({
    type: SET_SIZE,
    payload,
});
